/**
 * Replaces former Bootstrap JS: footer accordion, page nav accordion,
 * mobile menu tab panes, PDP feature <dialog> triggers.
 */
(function () {
  function initFooterAccordion() {
    var root = document.getElementById('footer-nav');
    if (!root) return;

    root.querySelectorAll('.accordion-button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var controls = btn.getAttribute('aria-controls');
        if (!controls) return;
        var panel = document.getElementById(controls);
        if (!panel) return;

        var isOpen = panel.classList.contains('show');

        root.querySelectorAll('.accordion-collapse').forEach(function (p) {
          p.classList.remove('show');
        });
        root.querySelectorAll('.accordion-button').forEach(function (b) {
          b.classList.add('collapsed');
          b.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          panel.classList.add('show');
          btn.classList.remove('collapsed');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initPageNavAccordion() {
    document.querySelectorAll('.page-nav .accordion-button[aria-controls]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var controls = btn.getAttribute('aria-controls');
        var panel = controls && document.getElementById(controls);
        if (!panel) return;

        var willOpen = !panel.classList.contains('show');
        if (willOpen) {
          panel.classList.add('show');
          btn.classList.remove('collapsed');
          btn.setAttribute('aria-expanded', 'true');
        } else {
          panel.classList.remove('show');
          btn.classList.add('collapsed');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  function initNavTabs() {
    var tablist = document.querySelector('#navigation #nav-tabs');
    if (!tablist) return;

    tablist.querySelectorAll('.nav-link').forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        var targetId = tab.getAttribute('aria-controls');
        if (!targetId) return;
        e.preventDefault();

        tablist.querySelectorAll('.nav-link').forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });

        var content = document.getElementById('nav-tabContent');
        if (content) {
          content.querySelectorAll('.tab-pane').forEach(function (pane) {
            pane.classList.remove('active', 'show');
          });
        }

        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        var pane = document.getElementById(targetId);
        if (pane) {
          pane.classList.add('active', 'show');
        }
      });
    });
  }

  function initFeatureDialogs() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.pot-feature-dialog-trigger');
      if (!btn) return;

      var id = btn.getAttribute('data-dialog-id');
      var dialog = id && document.getElementById(id);
      if (!dialog || typeof dialog.showModal !== 'function') return;

      var titleEl = dialog.querySelector('.pot-feature-dialog__title');
      var title = btn.getAttribute('data-feature-title') || '';
      if (titleEl) titleEl.textContent = title;

      dialog.showModal();
    });

    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('.pot-feature-dialog__close');
      if (!closeBtn) return;
      var d = closeBtn.closest('dialog');
      if (d) d.close();
    });

    document.querySelectorAll('dialog.pot-feature-dialog').forEach(function (d) {
      d.addEventListener('click', function (e) {
        if (e.target === d) d.close();
      });
    });
  }

  function run() {
    initFooterAccordion();
    initPageNavAccordion();
    initNavTabs();
    initFeatureDialogs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
